// import Swal from "sweetalert2";
import Swal from 'sweetalert2/dist/sweetalert2.js'

export default class Toaster
{
    static fire ( message )
    {
        let toastOptions = {
            // toast : true,
            html : message,
            // animation: false,
            position          : 'center',
            showConfirmButton : true,
            confirmButtonText : "OK",
            target            : 'body',
            // timer             : timeout,
            //timerProgressBar: true,
            // grow        : 'fullscreen',
            focusConfirm : true,
            // returnFocus  : false,
            stopKeydownPropagation : false,
            customClass            :
                {
                    popup : "toaster success",
                },
            showClass              : {
                backdrop : 'swal2-backdrop-show swal2-noanimation',
                icon     : false,
                popup    : 'animate__animated animate__slideInDown',
            },
            hideClass              : {
                backdrop : 'swal2-backdrop-show',
                icon     : false,
                popup    : 'animate__animated animate__fadeOutUp',
            },

            // In some cases, Vue (I think) was fighting for focus.
            // this way, we know the focus is grabbed AFTER it's opened
            didOpen : ( swalContainer ) =>
            {

                const btnConfirm = swalContainer.querySelector( '.swal2-actions button' );

                if ( btnConfirm )
                {
                    btnConfirm.focus();
                } else
                {
                    swalContainer.focus();
                }

            },
        }


        return Swal.fire( toastOptions );
    }
}


window.addEventListener( "show-toaster", ( e ) =>
{
    Toaster.fire( e.detail.message )
} );
